import React from "react";
import styled, { withTheme } from "styled-components/native";
import StoredImage from "./StoredImage";

/* Cropping and border for the image */
const Border = styled.View`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  border-radius: ${props => props.size / 2}px;
  overflow: hidden;
  border: ${props => props.border || props.theme.roundImageBorder};
  align-items: center;
  justify-content: center;
`;

/**
 * Displays a stored (in Amazon S3 for example) image which has the same width and height and is complete circular.
 *
 * In cases where the imageId is not specified, a placeholder is used instead.
 *
 * Props:
 * imageId: Token id of the image as found in the Amazon S3 bucket, this is used by the image resizer.
 * size: Width and height of the image as it will be shown.
 * border: Border to use for the outer rounded container. Defaults to the theme roundImageBorder.
 * placeholder: Image that will be used when the imageId is null.
 * templateIndex: Template index configured in the image resizer on the server side.
 */
const StoredRoundImage = ({ size, border, style, ...restProps }) => (
  <Border size={size} border={border} style={style}>
    <StoredImage
      {...restProps}
      width={size}
      height={size}
    />
  </Border>
);

export default withTheme(StoredRoundImage);
